var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled, { keyframes } from "styled-components";
import { colors } from "@wrstudios/theme";
var rotate = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
export var Container = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  svg {\n    width: 2rem;\n    height: 2rem;\n    fill: ", ";\n    animation: ", " linear infinite 800ms;\n    transform-origin: center;\n  }\n"], ["\n  svg {\n    width: 2rem;\n    height: 2rem;\n    fill: ", ";\n    animation: ", " linear infinite 800ms;\n    transform-origin: center;\n  }\n"])), colors.gray[800], rotate);
var templateObject_1, templateObject_2;